module.exports = __webpack_public_path__ + "img/artboard4.bd2f4dad.png";